export const formatCommaSeparatedName = (
  commaSeparatedName: string,
): string => {
  if (!commaSeparatedName) {
    return "";
  }

  const parts = commaSeparatedName.split(",").map((part) => part.trim());

  const reversedParts = [...parts].reverse();

  return reversedParts.join(" ");
};

export const formatProviderName = (name: string): string => {
  if (!name) return "";

  const hasSuffix = name.includes(",");

  if (hasSuffix) {
    const [fullName, suffix] = name.split(",").map((part) => part.trim());
    const nameParts = fullName.split(" ");

    if (nameParts.length >= 2) {
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ");
      return `${firstName} ${lastName}, ${suffix}`;
    }
    return name;
  } else {
    const nameParts = name.split(" ");

    if (nameParts.length >= 2) {
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ");

      return `${firstName} ${lastName}`;
    }

    return name;
  }
};
